// removed by extract-text-webpack-plugin
module.exports = {"outsideSalesDescription":"ContactDealerProcurementCta__outsideSalesDescription__665b8112","outsideSalesCTA":"ContactDealerProcurementCta__outsideSalesCTA__665b8112","emailIcon":"ContactDealerProcurementCta__emailIcon__665b8112"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/global/components/TradeProcurement/ContactDealerProcurementCta.scss
// module id = 3466
// module chunks = 4